export const getColor = (value) => {
    if(value >= 45 ) {
        return 'margin-item-green';
    } else if (value > 25 ) {
        return 'margin-item-yellow';
    } else {
        return 'margin-item-red';
    }
}